import { BILLING, PLAN_TIER } from '@wetransfer/transfer/constant/plan-tier';
import * as Routes from '@wetransfer/transfer/constant/routes';

export const createSignUpRoute = (
  tier: PLAN_TIER,
  billing: BILLING,
  trackingParam?: string,
  publicID?: string,
  signature?: string,
  prefillEmail?: string
): string => {
  const paramForTracking = trackingParam ? `&trk=${trackingParam}` : '';

  // These are used for assigning a transfer to a users account on signup. If they are present, they will be passed through the auth0 flow.
  const paramForPublicID = publicID ? `&public_id=${publicID}` : '';
  const paramForSignature = signature ? `&signature=${signature}` : '';

  // This is used for prefilling the email field on the auth0 sign up form
  const paramForPrefillEmail = prefillEmail
    ? `&prefill_email=${encodeURIComponent(prefillEmail)}`
    : '';

  return `${Routes.SIGN_UP.route}?tier=${tier}&billing=${billing}${paramForTracking}${paramForPublicID}${paramForSignature}${paramForPrefillEmail}`;
};

export const createUpgradeRoute = (
  tier: PLAN_TIER,
  billing: BILLING,
  trackingParam?: string
): string =>
  `${Routes.UPGRADE.route}?tier=${tier}&billing=${billing}${
    trackingParam ? `&trk=${trackingParam}` : ''
  }`;

export const createAccountPaymentRoute = (): string =>
  Routes.ACCOUNT_PAYMENT.route;

export const createPricingRoute = (trackingParam?: string): string => {
  if (trackingParam) {
    return `${Routes.PRICING.route}?trk=${trackingParam}`;
  }

  return Routes.PRICING.route;
};

export const createProRoute = (trackingParam?: string): string => {
  if (trackingParam) {
    return `${Routes.PRO.route}?trk=${trackingParam}`;
  }

  return Routes.PRO.route;
};

export const createCheckoutRoute = (
  tier: PLAN_TIER,
  billing: BILLING
): string => {
  const tierWithoutUnderscore = tier.replace('_', '');

  return `${window.checkoutUrl}?tier=${tierWithoutUnderscore}&billing=${billing}&redirect=transfer`;
};

export default {
  signUpRoute: createSignUpRoute,
  upgradeRoute: createUpgradeRoute,
  accountPaymentRoute: createAccountPaymentRoute,
  pricingRoute: createPricingRoute,
  proRoute: createProRoute,
  createCheckoutRoute: createCheckoutRoute,
};
